import * as React from "react";
import { Link } from "react-router-dom";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";

const styles = require("./privilegeInterests.scss");

interface IProps {
  privilegeInterest: Vingle.IPrivilegeInterest;
}

export default React.memo(function PrivilegeInterest(props: IProps) {
  const { privilegeInterest } = props;
  return (
    <Link
      to={new VingleURL.InterestCommons({
        interest: privilegeInterest.name,
      }).toString()}
      className={styles.item}
    >
      <IconWrapper
        className={styles.itemIcon}
        icon={PACKS.INTEREST_MARK.PROFILE.MY_INTEREST.INTEREST_MARK}
      />
      <strong className={styles.itemName}>
        {privilegeInterest.name.split(":")[0]}
      </strong>
      <span className={styles.itemLanguage}>{privilegeInterest.language}</span>
    </Link>
  );
});
